<template>
  <div class="user-grid">
    <div 
      class="user-card"
      v-bind:class="{'active-line-padding': selectedUser === user}"
      v-for="(user, index) in this.users" 
      :key="index"
      @click="selectRow(user)"
    >
      <div class="user-image" :style="'background-image:url(' + user.userPicture + ')'"></div>
      <h3>{{user.firstName + ' ' + user.lastName}}</h3>
      <span>{{user.isAdmin ? 'Administrator' : 'Operator'}}</span>
    </div>
  </div>
</template>

<script>
import BaseIcon from "@/components/base/Icon";

export default {
  components : {
    BaseIcon, 
  },
  computed : {},
  props: {
    users: Array
  },
  mounted() {    
  },
  data() {
    return {
      selectedUser: null,
    }
  },
  methods: {
    selectRow(user) {
      this.selectedUser = user
      this.$emit('selectedRow', user)
    },
  }
}
</script>

<style lang="scss" scoped>
  @import "../style/base.scss";
  @import "../style/components/active.scss";
  @import "../style/components/userGrid.scss";


</style>
